import IconSvg from 'src/components/common/ui/IconSvg';

interface BlurTableRowProps {
  blurIndex: number;
}

export default function BlurTableRow({ blurIndex }: BlurTableRowProps) {
  return (
    <div
      className={`grid grid-cols-15 px-5 py-[17.5px] rounded-md mb-2.5 last-of-type:mb-0 items-center bg-grayscale-800`}
    >
      <div className="flex items-center col-span-4 text-sm gap-x-5 text-grayscale-300">
        <img
          src={`/assets/images/blur-logo-${blurIndex}.png`}
          className="w-[60px] h-[60px] bg-cover bg-center"
        />

        <h5 className="text-brand-primary-light max-w-[255px] rounded-[5px]">
          <img
            src={`/assets/images/blur-collection-name-${Math.floor(Math.random() * 2) + 1}.png`}
            alt="blur collection name"
          />
        </h5>
      </div>

      <div className="col-span-2">
        <img src={'/assets/images/blur-collection-name-sm.png'} alt="blur price" />
      </div>

      <div className="col-span-2 flex flex-col gap-[9px]">
        <img src={'/assets/images/blur-price.png'} alt="blur price" className="w-[110px]" />
      </div>

      <div className="col-span-3 text-lg font-bold text-center text-grayscale-100"></div>

      <div className="col-span-2 text-sm text-grayscale-300">
        <div className="py-1 px-3 leading-none rounded-md bg-system-warning-dark border-system-warning flex gap-1.5 items-center border w-fit">
          <IconSvg icon="comingSoon2M" />
          <span className="text-sm text-grayscale-100">Soon</span>
        </div>
      </div>

      <div className="flex items-center justify-end col-span-2">
        <img src={'/assets/images/blur-button.png'} alt="blur button" />
      </div>
    </div>
  );
}
